import {type GatewayConfiguration} from '../../../models/GatewayConfiguration';
import {getLocaleText} from '../../../util/translation';
import {type AuthnetGateway} from '../authnet';
import bankImageURL from '../../../../img/marks/bank.svg';
import {Feature} from '../../../reducers/environmentReducer';
import {FeatureFlag} from '../../../../../@type/features';

function initAuthnetEcheckMethod(): AuthnetGateway {
	const config: GatewayConfiguration = {
		name: Feature.metadata<string>(FeatureFlag.AUTHNET_ECHECK_GATEWAY, 'title') ?? getLocaleText('US bank account'),
		gatewayId: 'peachpay_authnet_echeck',
		description: `${getLocaleText('After clicking <b>Pay</b>, a window will appear where you can enter your card information.')}`,
		assets: {
			title: {src: bankImageURL},
			badge: {src: bankImageURL},
		},
	};

	return {
		config,
	};
}

export {initAuthnetEcheckMethod};
